// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__gOv9P","footer":"ModalUpdate_footer__qxX7C"};